export default __webpack_public_path__ + "static/media/suliac-kitchen-min.2d50c3b4.jpg";